// @ts-check
import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { getAll } from "@/utilities/querySelector";

jQuery(function ($) {
    const sliders = getAll('[data-card-slider]');
    if (sliders.length) {
        sliders.forEach((slider) => {
            const size = slider.getAttribute("data-card-slider-size");
            const additionalOptions = JSON.parse(slider.getAttribute('data-slider-options') ?? '{}');

            let customOptions = {};
            let defaultOptions = {
                ...options,
                nextArrow,
                prevArrow
            };

            if (size === "tiny") {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 6,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 5,
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ],
                };
            } else if (size === "smallish") {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 5,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ],
                };
            } else if (size === "small") {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 4,
                    responsive: [
                        {
                            breakpoint: 1441,
                            settings: {
                                slidesToShow: 4,
                            }
                        },
                        {
                            breakpoint: 1250,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ],
                };
            } else if (size == "medium") {
                customOptions = {
                    ...defaultOptions,
                    centerMode: false,
                    slidesToShow: 2.5,
                    responsive: [
                        {
                            breakpoint: 1250,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 950,
                            settings: {
                                slidesToShow: 1.5,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ],
                };
            } else if (size == "large") {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 1.33,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ],
                };
            } else if (size == "huge") {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 1,
                };
            }

            $(slider).slick({
                ...customOptions,
                ...additionalOptions
            });
        });
    }
});